<template>
  <div v-if="isHomePage">
    <div class="row">
      <div class="col-12 col-md-4 gt-sm">
        <ProgressSteps :step="step"></ProgressSteps>
      </div>
      <div class="col-12 col-md-8">
        <div class="bg-white q-mx-md-md">
          <div class="header" v-if="!primaryImage">
            <img src="/assets/icons/header-logo.svg" class="header-logo" />
          </div>
          <div
            v-else
            :style="{
              backgroundImage: 'url(' + primaryImage + ')',
              height: '330px',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }"
          ></div>
          <div class="q-px-lg q-py-sm">
            <br />
            <MainHeadline align="center" :header="headerText" :body="bodyText" :secondBody="secondBody" />
            <hr />
          </div>
          <div class="q-px-lg q-pt-sm">
            <ProgressList
              :orderVerification="orderVerificationStatus()"
              :businessDetails="businessDetailsStatus()"
              :approvals="approvalsStatus()"
              :reviewSignContrct="reviewSignContrctStatus()"
            />
          </div>
          <div class="q-px-lg q-py-lg" style="text-align: center">
            <QBtn v-if="isApplicationFinished" color="primary" no-caps :to="{ name: 'logout' }">Log Out</QBtn>
            <QBtn v-else color="primary" class="full-width" no-caps @click="onClickHandler()" :loading="loading">Proceed</QBtn>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-view v-else />
</template>

<script>
import { QBtn } from 'quasar';
import ProgressSteps from '../../components/Molecules/ProgressSteps';
import ProgressList from '../../components/Molecules/ProgressList';
import MainHeadline from '../../components/Atoms/MainHeadline';
import { mapState, mapGetters } from 'vuex';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';

export default {
  name: 'Home',
  mixins: [MyCustomFunctions],
  computed: {
    ...mapState({
      applicationId: (state) => (state.vehicleApplication ? state.vehicleApplication?.vehicleApplication?.applicationId : null),
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null,
      user: (state) => state.auth.user
    }),
    ...mapGetters({
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant',
      orgProfile: 'theme/getScoreboard'
    }),
    currentStatus() {
      return this.scoreboard?.status ? this.scoreboard?.status : null;
    },
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    isQuoteReAssigned() {
      if (!this.primaryApplicant || (this.isUserPrimaryApplicant && this.primaryApplicant && this.primaryApplicant.confirmed !== 'yes'))
        return true;
      else return false;
    },
    headerText() {
      if (this.isQuoteReAssigned) return `Welcome ${this.capitalizeFirstLetter(this.user.firstName)}.`;

      if (this.currentStatus == 'finished') return 'Congratulations!';
      else if (
        this.currentStatus == 'orderVerification' ||
        this.currentStatus == 'businessDetails' ||
        this.currentStatus == 'approvals' ||
        this.currentStatus == 'reviewAndSignContract'
      )
        return 'Application in progress';
      else return `Welcome ${this.capitalizeFirstLetter(this.user.firstName)}.`;
    },
    bodyText() {
      if (!this.currentStatus)
        return 'Your account gives you access to step through the following steps, for which the status&#39; are shown.';

      if (this.isQuoteReAssigned)
        return `You\'ve been nominated as authorised officer of ${this.companyName} to participate in the review and approval of a vehicle quote, complete a credit application and sign the lease agreement.`;

      if (this.currentStatus == 'finished')
        return 'Your application is complete and we will contact you shortly about the delivery of your vehicle.';
      else if (
        this.currentStatus == 'orderVerification' ||
        this.currentStatus == 'businessDetails' ||
        this.currentStatus == 'approvals' ||
        this.currentStatus == 'reviewAndSignContract'
      )
        return '';
      return '';
    },
    companyName() {
      return this.scoreboard?.companyDetails?.companyName ? this.scoreboard?.companyDetails?.companyName : '';
    },
    step() {
      if (this.currentStatus == 'orderVerification') return 1;
      else if (this.currentStatus == 'businessDetails') return 2;
      else if (this.currentStatus == 'approvals') return 3;
      else if (this.currentStatus == 'reviewAndSignContract') return 4;
      else if (this.currentStatus == 'finished') return 5;
      return 0;
    },
    secondBody() {
      if (!this.currentStatus)
        return 'Quote Number: ' + (this.scoreboard?.quoteDetails?.milesQuoteRef || this.scoreboard?.quoteDetails?.erpQuoteRef || '');
      else if (this.isQuoteReAssigned) return null;
      else return 'Quote Number: ' + (this.scoreboard?.quoteDetails?.milesQuoteRef || this.scoreboard.quoteDetails.erpQuoteRef || '');
    },
    primaryImage() {
      if (this.orgProfile?.primaryImage) {
        return this.orgProfile.primaryImage;
      } else {
        return null;
      }
    },
    isApplicationFinished() {
      if (this.currentStatus == 'finished') return true;
      else return false;
    },
    isHomePage: function () {
      const pathName = this.$route.path;
      return pathName === `/applications/${this.applicationId}`;
    }
  },
  mounted() {
    if (!this.scoreboard) this.$router.push({ name: 'error' });
  },
  components: { QBtn, ProgressList, MainHeadline, ProgressSteps },
  data: function () {
    return {
      loading: false
    };
  },
  methods: {
    orderVerificationStatus: function () {
      switch (this.currentStatus) {
        case 'orderVerification':
          return 'progress';
        case 'businessDetails':
          return 'completed';
        case 'approvals':
          return 'completed';
        case 'reviewAndSignContract':
          return 'completed';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    businessDetailsStatus: function () {
      switch (this.currentStatus) {
        case 'orderVerification':
          return 'pending';
        case 'businessDetails':
          return 'progress';
        case 'approvals':
          return 'completed';
        case 'reviewAndSignContract':
          return 'completed';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    approvalsStatus: function () {
      switch (this.currentStatus) {
        case 'orderVerification':
          return 'pending';
        case 'businessDetails':
          return 'pending';
        case 'approvals':
          return 'progress';
        case 'reviewAndSignContract':
          return 'completed';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    reviewSignContrctStatus: function () {
      switch (this.currentStatus) {
        case 'orderVerification':
          return 'pending';
        case 'businessDetails':
          return 'pending';
        case 'approvals':
          return 'pending';
        case 'reviewAndSignContract':
          return 'progress';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    onClickHandler: async function () {
      this.loading = true;
      if (this.orderVerificationStatus() == 'pending') {
        await this.updateVehicleApplication('orderVerification', 'status');
        this.$router.push({ name: 'orderVerification' });
      } else if (this.orderVerificationStatus() == 'progress') {
        this.$router.push({ name: 'orderVerification' });
      } else if (this.businessDetailsStatus() == 'progress') {
        this.$router.push({ name: 'businessDetails' });
      } else if (this.approvalsStatus() == 'progress') {
        this.$router.push({ name: 'approvals' });
      } else if (this.reviewSignContrctStatus() == 'progress') {
        this.$router.push({ name: 'reviewAndSignContract' });
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
hr
  border: 0;
  border-top: 1px solid #EEEEEE;
.header
  padding: 50px 0 0;
  text-align: center;
  background-color: #E9F3FE;
  background-image: url('/assets/icons/header-background.svg');
  background-position: center top;
  background-repeat: no-repeat;
  min-height: 350px;
.header-logo
  width: 95%;
  max-width: 400px;
</style>
